module.exports = __webpack_public_path__ + "static/image/history/pc/202208@3x.jpg?cc11ffc9";